export default {
  setLoading(state, loading) {
    state.loading = loading;
  },
  setFilter(state, filter) {
    Object.assign(state.filter, filter);
  },
  setHasGeneratedReport(state, hasGeneratedReport) {
    state.hasGeneratedReport = hasGeneratedReport;
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-analytic/features/reports/pages/freight-cost/store/mutations.js